"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Link = void 0;

var tslib_1 = require("tslib");

var ui_blocks_1 = require("@hopin-team/ui-blocks");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var styled_components_1 = tslib_1.__importDefault(require("styled-components"));

exports.Link = styled_components_1.default.a(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  ", "\n\n  color: ", ";\n  border-bottom: none;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n"], ["\n  ", "\n\n  color: ", ";\n  border-bottom: none;\n  margin-left: 0.5rem;\n  margin-right: 0.5rem;\n"])), ui_blocks_1.INTERACTIVE.base, function (_a) {
  var theme = _a.theme;
  return ui_helper_deep_branding_1.getFromTheme('COLOR.GREY.600', theme);
});
var templateObject_1;